var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUncashedCheck = function SvgUncashedCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B216B",
    fillRule: "evenodd",
    d: "M48.667 52a8.667 8.667 0 1 0 0-17.333 8.667 8.667 0 0 0 0 17.333m0 2.667C54.926 54.667 60 49.593 60 43.333S54.926 32 48.667 32s-11.334 5.074-11.334 11.333 5.074 11.334 11.334 11.334M15 35.58c.23.28.53.42.835.42.297 0 .589-.135.818-.401l2.003-2.357 1.526 1.77 2.286-1.377 1.425 1.403h8.274c.645 0 1.166-.629 1.166-1.4 0-.772-.52-1.4-1.166-1.4h-7.44l-1.953-1.92-2.16 1.302-1.97-2.287-3.627 4.265c-.46.542-.468 1.428-.017 1.981",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B216B",
    fillRule: "evenodd",
    d: "M8 14.667H6.667v26.666h29.49c.147-.926.394-1.819.73-2.666H9.333V17.333h44v14.221c.951.377 1.845.866 2.667 1.45V14.667H8",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B216B",
    fillRule: "evenodd",
    d: "M13.333 25.333H12V28h38.667v-2.667H13.333M12 20h38.667v2.667H12z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M47.333 36.667H50v8h-2.667z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B216B",
    fillRule: "evenodd",
    d: "M50 36.667h-2.667v8H50z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B216B",
    d: "M50 48a1.333 1.333 0 1 1-2.667 0A1.333 1.333 0 0 1 50 48"
  })));
};
export { SvgUncashedCheck as Icon };
export default __webpack_public_path__ + "static/media/eaabdee876ff6c67fa18f5f8191bac4d.svg";